// https://react.dev/reference/react/createContext#createcontext
// https://stackoverflow.com/questions/64721996/gatsby-js-build-error-webpackerror-typeerror-cannot-destructure-property-use

import { createContext } from 'react'
import defaultValue from '../hooks/useGetAppValue'
const AppContext = createContext(defaultValue)
export default AppContext
